// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { is24meApp } from 'utils/appType'

const config = {
  appId: is24meApp()
    ? '9f8f5476-d457-456c-80be-ec7a41748c6b'
    : 'a3adc950-151b-41c1-9a06-936edc124bf3',
  redirectUri: process.env.REACT_APP_LINK_DOMAIN,
  scopes: ['calendars.readwrite']
}

export default config
